import { NotificationTypes } from '@chegg-ui/notification-banner'
import {
  CancelCircleIcon,
  CopyIcon,
  ThumbsUpIcon,
  WarningCircleIcon,
} from '@chegg-ui/horizon-icons'
import { Dispatch } from 'redux'
import { clearToast, reviewPaper } from '@chegg-wt/core-wa/state/actions'
import { colors, FlagIcon } from '@chegg-ui/theme'
import { ToastType } from '@chegg-wt/core-wa/state/types'
import { AppRouteCreators } from '@chegg-wt/core/types/core'
import { CopyMap } from './types'

export const ToastMessages: CopyMap = {
  [ToastType.COPY]: {
    iconOverride: <CopyIcon color={colors.dark} size="medium" />,
    message: 'The text has been copied to your clipboard',
    persist: false,
    type: NotificationTypes.Offer,
  },
  [ToastType.FLAG]: {
    iconOverride: <FlagIcon color={colors.dark} size="medium" />,
    message: 'Suggestion flagged.',
    persist: false,
    type: NotificationTypes.Offer,
  },
  [ToastType.GRAMMAR_ERROR]: {
    iconOverride: <CancelCircleIcon size="medium" />,
    title: 'Something went wrong',
    message:
      'You’re grammar feedback suggestions are not loading properly. Let’s try reviewing your paper once more ',
    persist: true,
    type: NotificationTypes.Error,
    ctaLinkText: 'Review my paper',
    ctaLinkOnClickHandler: (dispatch: Dispatch, routes: AppRouteCreators) => {
      dispatch(reviewPaper({ routes }))
      dispatch(clearToast())
    },
  },
  [ToastType.CLARITY_ERROR]: {
    iconOverride: <CancelCircleIcon size="medium" />,
    title: 'Something went wrong',
    message:
      'You’re clarity feedback suggestions are not loading properly. Let’s try reviewing your paper once more',
    persist: true,
    type: NotificationTypes.Error,
    ctaLinkText: 'Review my paper',
    ctaLinkOnClickHandler: (dispatch: Dispatch, routes: AppRouteCreators) => {
      dispatch(reviewPaper({ routes }))
    },
  },
  [ToastType.QUICK_ACTION_RETRY_ERROR]: {
    iconOverride: <CancelCircleIcon size="medium" />,
    title: 'Let’s give it another try',
    message: 'We ran into a problem re-working your writing. Please',
    persist: true,
    type: NotificationTypes.Error,
    ctaLinkText: 'try again later.',
    ctaLinkOnClickHandler: (dispatch: Dispatch, routes: AppRouteCreators) => {
      dispatch(reviewPaper({ routes }))
    },
  },
  [ToastType.CLARITY_REASON_ERROR]: {
    iconOverride: <CancelCircleIcon size="medium" />,
    title: `Let's give it another try`,
    message: `We weren't able to load this section. Please try again.`,
    persist: false,
    type: NotificationTypes.Error,
  },
  [ToastType.SAVING_PAPER]: {
    iconOverride: <ThumbsUpIcon color={colors.dark} size="medium" />,
    message: (title: string) => `Saving ${title}`,
    persist: false,
    type: NotificationTypes.Offer,
  },
  [ToastType.DRAFT_PAPER_EXISTS]: {
    iconOverride: <WarningCircleIcon color={colors.dark} size="medium" />,
    message: 'You are already on a new paper.',
    persist: false,
    type: NotificationTypes.Offer,
  },
  [ToastType.SAVING_PAPER_ERROR]: {
    iconOverride: <CancelCircleIcon size="medium" />,
    title: 'Something went wrong',
    message: (title: string) => `Saving failed ${title}`,
    persist: true,
    type: NotificationTypes.Error,
  },
}
